import React from 'react';
import { useLocation } from 'react-router-dom';
import { projects } from '../../projectsData';
import Button from '../Button';


const ProjectDetails = () => {
    // react-router hooks
    const location = useLocation();
    const paths = location.pathname.split('/');
    const id = paths[paths.length - 1];

    // get projets details
    const project = projects.filter(item => item.id == id)[0];

    // destructure data
    const { title, sub_title, body, image2, tech, git, live } = project;

    return (
        <section className='px-3 pt-10 md:p-5 mb-12'>
            <div>
                <h1 className='text-3xl font-bold mt-3 text-gray-800'>{title}</h1>
                <h6 className='text-sm text-gray-700 -mt-1'>{sub_title}</h6>
            </div>
            <div className='mt-3'>
                <img className='w-full h-full object-contain rounded' src={image2} alt={title} />
            </div>
            <div className='mt-3'>
                <p className='text-justify'>{body}</p>
            </div>
            <div className='flex flex-wrap mt-4'>
                {
                    tech.map(item => <p className='text-sm bg-gray-600 py-1 text-gray-200 px-3 mr-2 mt-2 rounded-full capitalize shadow-lg'>{item}</p>)
                }
            </div>
            <div className='flex mr-2 mt-3'>
                <Button name='github' link={git} />
                <Button name='live site' link={live} />
            </div>
        </section>
    )
}

export default ProjectDetails;
